/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Unmatched_TitleInputs */

const vi_warehouse_unmatched_title = /** @type {(inputs: Warehouse_Unmatched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã chưa khớp sản phẩm`)
};

/**

* @param {Warehouse_Unmatched_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_unmatched_title = /** @type {((inputs?: Warehouse_Unmatched_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Unmatched_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_unmatched_title(inputs)
});